/**
 * Sidebar Manager - Handles sidebar collapse/expand functionality
 */
export class SidebarManager {
    constructor() {
        this.SIDEBAR_STATE_KEY = 'volvo-portal-sidebar-collapsed';
        this.sidebarMenu = null;
        this.sidebarToggleButton = null;
        this.isCollapsed = false;
        this.isCollapsed = localStorage.getItem(this.SIDEBAR_STATE_KEY) === 'true';
    }
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeSidebar();
            });
        }
        else {
            this.initializeSidebar();
        }
    }
    initializeSidebar() {
        this.sidebarMenu = document.getElementById('sidebarMenu');
        this.sidebarToggleButton = document.getElementById('sidebar-toggle');
        if (!this.sidebarMenu) {
            console.warn('Sidebar element not found');
            return;
        }
        // Apply saved state
        if (this.isCollapsed) {
            this.collapseSidebar();
        }
        // Setup toggle button
        if (this.sidebarToggleButton) {
            this.sidebarToggleButton.addEventListener('click', () => {
                this.toggleSidebar();
            });
        }
    }
    toggleSidebar() {
        if (this.isCollapsed) {
            this.expandSidebar();
        }
        else {
            this.collapseSidebar();
        }
    }
    collapseSidebar() {
        if (!this.sidebarMenu)
            return;
        this.sidebarMenu.classList.add('sidebar-collapsed');
        this.isCollapsed = true;
        localStorage.setItem(this.SIDEBAR_STATE_KEY, 'true');
        // Close all open submenus when collapsing
        this.closeAllSubmenus();
        // Enable tooltips when collapsed
        this.enableTooltips();
        // Dispatch event for other components
        window.dispatchEvent(new CustomEvent('sidebar-collapsed', { detail: { collapsed: true } }));
    }
    closeAllSubmenus() {
        const submenus = this.sidebarMenu?.querySelectorAll('.collapse.show');
        submenus?.forEach((submenu) => {
            if (window.bootstrap?.Collapse?.getInstance(submenu)) {
                window.bootstrap.Collapse.getInstance(submenu).hide();
            }
            else if (window.bootstrap?.Collapse) {
                new window.bootstrap.Collapse(submenu, { toggle: false }).hide();
            }
        });
    }
    expandSidebar() {
        if (!this.sidebarMenu)
            return;
        this.sidebarMenu.classList.remove('sidebar-collapsed');
        this.isCollapsed = false;
        localStorage.setItem(this.SIDEBAR_STATE_KEY, 'false');
        // Disable tooltips when expanded
        this.disableTooltips();
        // Dispatch event for other components
        window.dispatchEvent(new CustomEvent('sidebar-collapsed', { detail: { collapsed: false } }));
    }
    enableTooltips() {
        const navLinks = this.sidebarMenu?.querySelectorAll('.nav-link');
        navLinks?.forEach((link) => {
            const tooltipEl = link;
            // Check if tooltip already exists
            if (window.bootstrap?.Tooltip?.getInstance(tooltipEl)) {
                return;
            }
            // Create new tooltip
            if (window.bootstrap?.Tooltip) {
                new window.bootstrap.Tooltip(tooltipEl);
            }
        });
    }
    disableTooltips() {
        const navLinks = this.sidebarMenu?.querySelectorAll('.nav-link');
        navLinks?.forEach((link) => {
            const tooltipEl = link;
            const tooltipInstance = window.bootstrap?.Tooltip?.getInstance(tooltipEl);
            if (tooltipInstance) {
                tooltipInstance.dispose();
            }
        });
    }
    isSidebarCollapsed() {
        return this.isCollapsed;
    }
}
export default SidebarManager;
